import type { SVGProps } from "react";
import { memo } from "react";
const SageMakerStudioLab = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M46.909 55.046H66v-30H46.909zm-5.909 0h4v-30h-4v5h2v2h-2v7h2v2h-2v7h2v2h-2zm27-31v32a1 1 0 0 1-1 1H40a1 1 0 0 1-1-1v-6h-2v-2h2v-7h-2v-2h2v-7h-2v-2h2v-6a1 1 0 0 1 1-1h27a1 1 0 0 1 1 1m-29 35.09h2v3.026a1 1 0 0 1-.513.873l-7.128 3.983a.99.99 0 0 1-.985-.006l-13.872-7.966a1 1 0 0 1-.502-.867v-8.483l-5.46-2.832a1 1 0 0 1-.54-.887V33.046a1 1 0 0 1 .49-.86L18 28.92v-8.983c0-.366.201-.704.523-.878l12.972-7.038c.289-.155.637-.162.928-.013l8.027 4.064c.337.17.549.515.549.89L41 20.956h-2v-3.376l-7.013-3.55L30 15.108v8.938h-2v-7.853l-8 4.34v6.956l6.987 4.329L32 28.458v-5.412h2v5.947a1 1 0 0 1-.443.83L28 33.547v4.499h5v2h-5.697l-5.748 3.832-1.11-1.664L26 38.51v-4.952l-6.053-3.75a1 1 0 0 1-.437.54L14 33.617v4.743l6.354-4.236 1.11 1.664L14 40.763v4.606l5.207 2.7 5.2-3.828 1.186 1.61L20 49.969v7.63l6.584 3.782-.114-.183L29 59.616v-10.57h2v9.32l3.47-2.168 1.06 1.696-7.191 4.495 4.54 2.607L39 61.575z"
      />
    </g>
  </svg>
);
const Memo = memo(SageMakerStudioLab);
export default Memo;
